<!--
 * @Description: 个人中心
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-29 14:31:01
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>个人中心</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <!-- <v-list>
              <v-list-item v-for="(item, i) in 5" :key="i" @click="() => {}">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>-->
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>头像</v-list-item-subtitle>
                <v-list-item-title>
                  <v-list-item-avatar>
                    <!-- thumb_url -->
                    <v-img v-if="data.thumb_url !== ''" :src="data.thumb_url"></v-img>
                    <v-img v-else src="../../assets/20191028190529.png"></v-img>
                  </v-list-item-avatar>
                  <br>
                  <input type="file" name="" id="btn_file" hidden >
                  <v-btn color="primary" text @click="doctor_avatar">更换头像</v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>账号</v-list-item-subtitle>
              <v-list-item-title>{{ data.phone }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>姓名</v-list-item-subtitle>
              <v-list-item-title>{{ data.name }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>职称</v-list-item-subtitle>
              <v-list-item-title v-if="data.level == 1" > 主任医师 </v-list-item-title>
              <v-list-item-title v-else-if="data.level == 2" > 副主任医师 </v-list-item-title>
              <v-list-item-title v-else-if="data.level == 3" > 主治医师 </v-list-item-title>
              <v-list-item-title v-else-if="data.level == 4" > 住院医师 </v-list-item-title>
              <v-list-item-title v-else-if="data.level == 5" > 助理医师 </v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>执业点</v-list-item-subtitle>
              <v-list-item-title>{{ data.workplaces[0].area }}-{{ data.workplaces[0].name }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>擅长领域</v-list-item-subtitle>
              <p>{{ data.speciality }}</p>
            </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>  
            <v-list-item-content>
              <v-list-item-subtitle>个人简介</v-list-item-subtitle>
              <p>{{ data.intro.post_title }}</p>
            </v-list-item-content>
            </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="change">信息变更？</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      data:{
        thumb_url:'',
        phone:'',
        name:'',
        level:'',
        workplaces:[{area:''}],
        speciality:'',
        intro:{
          post_title:''
        }
      }
    };
  },
  methods: {
    info(state,data) {
      this.dialog = state;
      this.data = data;
    },
    change(){
      this.dialog = false;
      this.$router.push({
                  path: `/SubmitReview`,
                  query: {}
                });
    },
    /* 上传头像 */ 
    doctor_avatar(){
      // doctor_avatar
      document.getElementById("btn_file").click();
      document.getElementById("btn_file").onchange = ()=>{
        this.$Dialog.getProductCheckResult_({text: `医生头像正在上传...`,timeout: 3000, snackbar: true });
        let formData = new FormData();
        formData.append("file", document.getElementById("btn_file").files[0]);
        this.$axios({
        method: "post",
        url: this.$apis.URL.doctor_avatar,
        data: formData
      })
        .then((req) => {
          if(req.data.result == 0){
            this.$Dialog.getProductCheckResult_({text: `医生头像成功！`,timeout: 3000, snackbar: true });
            this.dialog = false;
            this.$parent.$parent.doctorInfo();
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
      }
    }
  }
};
</script>